module.exports = __webpack_public_path__ + "static/media/outlet-settings.6e4a3455.svg";